import { ModuleAccessLevel } from '../../constants-types';

export const AllowedAccessLevels: ModuleAccessLevel[] = [
    ModuleAccessLevel.CommonAccess,
    ModuleAccessLevel.BasicAccess
];
